import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ServerTableResponse } from '@shared/types';
import { Observable } from 'rxjs';
import { UtilsService } from './utils.service';

export interface Entity {
  entity_name: string;
}

/**
 * Service responsible for handling entity-related API operations.
 */
@Injectable({ providedIn: 'root' })
export class EntitiesService {
  private http = inject(HttpClient);
  private utilsService = inject(UtilsService);

  /**
   * Retrieves all entities from the API.
   * @returns An Observable of Entity array containing all entities
   */
  public getEntities(): Observable<ServerTableResponse<Entity[]>> {
    const url = this.utilsService.buildApiUrl('utils/entities');
    return this.http.get<ServerTableResponse<Entity[]>>(url);
  }
}
